<template>
    <div>
        <div>
            <h2 class="title is-4">
                Request Repair
            </h2>

            <h4 class="subtitle is-6 mb-5">
                Use the form below to log a fault with your property.
            </h4>

            <FixfloEstateIframe />
        </div>
    </div>
</template>

<script>
import FixfloEstateIframe from '../components/FixfloEstateIframe.vue';

export default {
    components: {
        FixfloEstateIframe,
    },
};
</script>
